import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: the page itself lives in es.industrias.in-vitro-diagnostics.index.tsx. Without this wrapper the
// page component would shadow every nested child route.
export const Route = createFileRoute("/es/industrias/in-vitro-diagnostics")({
  component: RouteLayout,
});

function RouteLayout() {
  return <Outlet />;
}
